import styled from "styled-components";
import { useLanguage } from "../../../../providers/LanguageProvider";
import gistLogo from "../../../../assets/Logos/gist_logo.svg";

const LANGUAGES = [
  { name: "English", value: "en" },
  { name: "Español", value: "es" },
  { name: "Português", value: "pt" },
];

export default function GIPatientHeader({ padding = "8px 0px" } = {}) {
  const { lang: selectedLanguage, setLang } = useLanguage();

  const handleLanguageChange = (lang) => {
    if (lang !== selectedLanguage) {
      setLang(lang);
    }
  };

  return (
    <>
      <Header $padding={padding}>
        <GILogo src="/gilogo.svg" alt="University Gastroenterology" />
        <PoweredBy>
          <GistLogo src={gistLogo} alt="GistMD" />
        </PoweredBy>
      </Header>
      <LanguageBar>
        {LANGUAGES.map((lang, idx) => (
          <span key={lang.value}>
            <LanguageOption
              $active={selectedLanguage === lang.value}
              onClick={() => handleLanguageChange(lang.value)}
            >
              {lang.name}
            </LanguageOption>
            {idx < LANGUAGES.length - 1 && <LanguageDivider>|</LanguageDivider>}
          </span>
        ))}
      </LanguageBar>
    </>
  );
}

const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  padding: ${({ $padding }) => $padding};
  box-sizing: border-box;
`;

const GILogo = styled.img`
  height: 50px;
  width: auto;
  object-fit: contain;
`;

const PoweredBy = styled.div`
  display: flex;
  align-items: center;
`;

const GistLogo = styled.img`
  height: 35px;
  width: auto;
  object-fit: contain;
`;

const LanguageBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 0;
  width: 100%;
`;

const LanguageOption = styled.span`
  font-family: "Abraham", sans-serif;
  font-size: 16px;
  cursor: pointer;
  color: ${({ $active }) => ($active ? "#7A9DFD" : "#333")};
  font-weight: ${({ $active }) => ($active ? "600" : "400")};

  &:hover {
    color: #7A9DFD;
  }
`;

const LanguageDivider = styled.span`
  color: #ccc;
  margin: 0 8px;
`;
